import React, { useContext, useEffect, useState } from "react";
import {
  ContentState,
  EditorState,
  convertFromHTML,
  convertToRaw,
} from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import venomContext from "../../context/venomContext";
import { toast } from "react-toastify";
import { Link, useOutletContext } from "react-router-dom";
import classNames from "classnames";
// import Select from "react-select";
// import makeAnimated from "react-select/animated";

export default function UserAllBlogs() {
  const context = useContext(venomContext);
  const [currentUser] = useOutletContext();
  const {
    createBlog,
    allBlogs,
    blogs,
    allCategories,
    categories,
    // getCurrentUserBlogs,
    // currentUserBlogs,
    updateBlog,
    deleteBlog,
  } = context;
  // const animatedComponents = makeAnimated();
  // const MoreOptions = [
  //   { value: "chocolate", label: "Chocolate" },
  //   { value: "strawberry", label: "Strawberry" },
  //   { value: "vanilla", label: "Vanilla" },
  // ];
  // let options = [];
  // for (let i = 0; i < tags.length; i++) {
  //   let a = tags[i].tags[0];
  //   let b = a.charAt(0).toUpperCase() + a.slice(1, a.length);
  //   options.push({ value: a, label: b });
  // }
  const { all_cat } = categories;
  const [blogContent, setBlogContent] = useState({
    title: "",
    category: "",
  });
  const [blogExistingContent, setBlogExistingContent] = useState({
    id: "",
    updated_title: "",
    updated_category: "",
    updated_description: "",
    updated_blog_feature_img: "",
  });
  // const [selected, setSelected] = useState("");
  const [blogFeaturedImg, setBlogFeaturedImg] = useState({
    blogFeatureImg: "",
  });
  const [longDesc, setLongDesc] = useState("");
  const [isEdited, setIsEdited] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const theme_color = localStorage.getItem("theme");
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  // isEdited === true
  //     ? EditorState.createWithContent(
  //         ContentState.createFromBlockArray(
  //           convertFromHTML(
  //             blogExistingContent.description
  //           )
  //         )
  //       )
  const onEditorStateChange = (editState) => {
    setEditorState(editState);
    const DraftToHtml = draftToHtml(
      convertToRaw(editorState.getCurrentContent())
    );
    setLongDesc(DraftToHtml);
  };

  const ModelOnChange = (e) => {
    setBlogContent({ ...blogContent, [e.target.name]: e.target.value });
  };

  // const handleChange = (selectedOption) => {
  //   setSelected(selectedOption);
  // };

  const BlogFeatureImgHandler = (e) => {
    setIsNew(true);
    const files = e.target.files[0];
    let fileSize = files.size;
    let fileMb = fileSize / 1024 ** 2;
    if (fileMb >= 1) {
      toast.warn("File size should be less than 1MB", {
        position: "bottom-right",
      });
      e.target.value = "";
      setBlogFeaturedImg({ blogFeatureImg: "" });
      return;
    }
    let reader = new FileReader();
    reader.onload = () => {
      setBlogFeaturedImg({ [e.target.name]: reader.result });
    };
    reader.readAsDataURL(files);
  };

  const createBlogHandler = async () => {
    const { title, category } = blogContent;
    const { blogFeatureImg } = blogFeaturedImg;
    if (isEdited === true) {
      const {
        updated_title,
        updated_description,
        updated_blog_feature_img,
        updated_category,
        id,
      } = blogExistingContent;
      if (!updated_blog_feature_img) {
        return toast.warn("All fields are required", {
          position: "bottom-right",
        });
      }
      updateBlog(
        title || updated_title,
        longDesc || updated_description,
        blogFeatureImg || updated_blog_feature_img,
        category || updated_category,
        id
      );
    } else {
      if (!title || !category || !blogFeatureImg || !longDesc) {
        return toast.warn("All fields are required", {
          position: "bottom-right",
        });
      }
      createBlog(title, category, blogFeatureImg, longDesc);
      document.getElementById("title").value = "";
      document.getElementById("category").value = "";
      document.getElementById("blog_feature_img").value = "";
      setEditorState("");
    }
  };

  useEffect(() => {
    allCategories();
    allBlogs();
    // getCurrentUserBlogs();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="blogs-all d-flex justify-content-between align-items-center mt-4">
        <h3
          className={classNames("m-0", {
            "text-light": localStorage.getItem("mode") === "dark",
          })}
        >
          All Blogs
        </h3>
        <div className="right-content">
          <i
            className="fas fa-sync me-3"
            style={{ cursor: "pointer" }}
            onClick={async (e) => {
              e.target.classList.add("active");
              await allBlogs();
              // await getCurrentUserBlogs();
              e.target.classList.remove("active");
              toast.success("Blogs updated", {
                position: "bottom-right",
              });
            }}
          ></i>
          <button
            className={"btn btn-md btn-" + theme_color}
            data-bs-toggle="modal"
            data-bs-target="#exampleModal"
          >
            Create Blog
          </button>
        </div>
      </div>
      <div className="tabular-data">
        <table className="table table-bordered align-middle table-striped table-hover mt-3">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Name</th>
              <th scope="col">Category</th>
              <th scope="col">Feature Image</th>
              <th scope="col">Author</th>
              <th scope="col">Updated at</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            {!blogs ||
              (blogs.length === 0 && (
                <tr>
                  <td colSpan={7} className="text-center">
                    <h6 className="m-0">No Blogs Found</h6>
                  </td>
                </tr>
              ))}
            {currentUser && (
              <>
                {blogs.blogs &&
                  blogs.blogs.map((curElem, index) => {
                    const {
                      _id,
                      title,
                      category,
                      blog_feature_img,
                      author,
                      updatedAt,
                      description,
                      user,
                    } = curElem;
                    var date = new Date(updatedAt);
                    let splitedDate = date.toString().split(" ");
                    let month = splitedDate[1];
                    let day = splitedDate[2];
                    let year = splitedDate[3];
                    var hours = date.getHours();
                    var minutes = date.getMinutes();
                    var ampm = hours >= 12 ? "pm" : "am";
                    hours = hours % 12;
                    hours = hours ? hours : 12; // the hour '0' should be '12'
                    hours = hours < 10 ? "0" + hours : hours;
                    minutes = minutes < 10 ? "0" + minutes : minutes;
                    var dateTime =
                      month +
                      ", " +
                      day +
                      " " +
                      year +
                      " at " +
                      hours +
                      ":" +
                      minutes +
                      " " +
                      ampm;
                    return (
                      <tr key={_id}>
                        <th scope="row">{index + 1}</th>
                        <td>
                          <Link target="_blank" to={"/single/" + _id}>
                            {title}
                          </Link>
                        </td>
                        <td>{category}</td>
                        <td>
                          <img src={blog_feature_img} width={50} alt="" />
                        </td>
                        <td>{author}</td>
                        <td>{dateTime}</td>
                        <td colSpan="2">
                          {currentUser._id === user ? (
                            <>
                              <i
                                className="fas fa-edit me-2"
                                data-bs-toggle="modal"
                                data-bs-target="#exampleModal"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setIsEdited(true);
                                  setBlogExistingContent({
                                    id: _id,
                                    updated_title: title,
                                    updated_category: category,
                                    updated_description: description,
                                    updated_blog_feature_img: blog_feature_img,
                                  });
                                  setEditorState(
                                    EditorState.createWithContent(
                                      ContentState.createFromBlockArray(
                                        convertFromHTML(description)
                                      )
                                    )
                                  );
                                }}
                              ></i>
                              <i
                                className="fas fa-trash-alt"
                                style={{ cursor: "pointer" }}
                                onClick={(e) => {
                                  e.target.classList.remove("fa-trash-alt");
                                  e.target.classList.add("fa-sync", "active");
                                  deleteBlog(currentUser._id === user && _id);
                                  // await getCurrentUserBlogs();
                                  setTimeout(async () => {
                                    await allBlogs();
                                    await allCategories();
                                    e.target.classList.add("fa-trash-alt");
                                    e.target.classList.remove(
                                      "fa-sync",
                                      "active"
                                    );
                                  }, 3000);
                                }}
                              ></i>
                            </>
                          ) : (
                            <>
                              {currentUser.role === "admin" && (
                                <>
                                  <i
                                    className="fas fa-edit me-2"
                                    data-bs-toggle="modal"
                                    data-bs-target="#exampleModal"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setIsEdited(true);
                                      setBlogExistingContent({
                                        id: _id,
                                        updated_title: title,
                                        updated_category: category,
                                        updated_description: description,
                                        updated_blog_feature_img:
                                          blog_feature_img,
                                      });
                                      setEditorState(
                                        EditorState.createWithContent(
                                          ContentState.createFromBlockArray(
                                            convertFromHTML(description)
                                          )
                                        )
                                      );
                                    }}
                                  ></i>
                                  <i
                                    className="fas fa-trash-alt"
                                    style={{ cursor: "pointer" }}
                                    onClick={async (e) => {
                                      e.target.classList.remove("fa-trash-alt");
                                      e.target.classList.add(
                                        "fa-sync",
                                        "active"
                                      );
                                      deleteBlog(_id);
                                      setTimeout(async () => {
                                        await allBlogs();
                                        await allCategories();
                                        e.target.classList.add("fa-trash-alt");
                                        e.target.classList.remove(
                                          "fa-sync",
                                          "active"
                                        );
                                        // await getCurrentUserBlogs();
                                      }, 3000);
                                    }}
                                  ></i>
                                </>
                              )}
                            </>
                          )}
                        </td>
                      </tr>
                    );
                  })}
              </>
            )}
          </tbody>
        </table>
      </div>

      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {isEdited === true ? "Update Blog" : "Create Blog"}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setBlogExistingContent({
                    id: "",
                    updated_title: "",
                    updated_category: "",
                    updated_description: "",
                    updated_blog_feature_img: "",
                  });
                  setBlogContent({ title: "", category: "" });
                  setBlogFeaturedImg({ blogFeatureImg: "" });
                  document.getElementById("title").value = "";
                  document.getElementById("category").value = "";
                  document.getElementById("blog_feature_img").value = "";
                  setLongDesc("");
                  setIsNew(false);
                  setIsEdited(false);
                  setEditorState(EditorState.createEmpty());
                }}
              ></button>
            </div>
            <div className="modal-body">
              <div className="blog-form">
                <div className="form-group">
                  <label htmlFor="title">Title</label>
                  <input
                    value={
                      blogContent.title === ""
                        ? blogExistingContent.updated_title
                        : blogContent.title
                    }
                    type="text"
                    name="title"
                    onChange={ModelOnChange}
                    className={"form-control my-2 input-" + theme_color}
                    id="title"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="category">Category</label>
                  <select
                    className={"form-control my-2 input-" + theme_color}
                    name="category"
                    value={
                      blogContent.category === ""
                        ? blogExistingContent.updated_category
                        : blogContent.category
                    }
                    id="category"
                    onChange={ModelOnChange}
                  >
                    <option style={{ pointerEvents: "none" }}>
                      Select Category
                    </option>
                    {all_cat &&
                      all_cat.map((curElem) => {
                        const { _id, cat_name } = curElem;
                        return <option key={_id}>{cat_name}</option>;
                      })}
                  </select>
                </div>
                <div className="form-group mt-2">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className={isNew === false && "w-100"}>
                      <label htmlFor="blog_feature_img">Blog Feature Img</label>
                      <input
                        type="file"
                        onChange={BlogFeatureImgHandler}
                        name="blogFeatureImg"
                        className={"form-control my-2 input-" + theme_color}
                        id="blog_feature_img"
                      />
                    </div>
                    {isEdited === true && (
                      <div className="img-preview">
                        <img
                          className={isNew === false && "ms-3"}
                          style={{ height: 50, marginTop: 15 }}
                          src={
                            blogFeaturedImg.blogFeatureImg === ""
                              ? blogExistingContent.updated_blog_feature_img
                              : blogFeaturedImg.blogFeatureImg
                          }
                          alt=""
                        />
                      </div>
                    )}
                    {isNew === true && isEdited === false && (
                      <div className="img-preview">
                        <img
                          style={{ height: 50, marginTop: 15 }}
                          src={blogFeaturedImg.blogFeatureImg}
                          alt=""
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <Editor
                editorState={editorState}
                wrapperClassName="wrapper-class"
                editorClassName="editor-class"
                toolbarClassName="toolbar-class"
                onEditorStateChange={onEditorStateChange}
                mention={{
                  separator: " ",
                  trigger: "#",
                  suggestions: [
                    { text: "APPLE", value: "apple" },
                    { text: "BANANA", value: "banana", url: "banana" },
                    { text: "CHERRY", value: "cherry", url: "cherry" },
                    { text: "DURIAN", value: "durian", url: "durian" },
                    {
                      text: "EGGFRUIT",
                      value: "eggfruit",
                      url: "eggfruit",
                    },
                    { text: "FIG", value: "fig", url: "fig" },
                    {
                      text: "GRAPEFRUIT",
                      value: "grapefruit",
                      url: "grapefruit",
                    },
                    {
                      text: "HONEYDEW",
                      value: "honeydew",
                      url: "honeydew",
                    },
                  ],
                }}
                placeholder="Tell your story..."
              />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={() => {
                  setBlogExistingContent({
                    id: "",
                    updated_title: "",
                    updated_category: "",
                    updated_description: "",
                    updated_blog_feature_img: "",
                  });
                  setBlogContent({ title: "", category: "" });
                  setBlogFeaturedImg({ blogFeatureImg: "" });
                  document.getElementById("title").value = "";
                  document.getElementById("category").value = "";
                  document.getElementById("blog_feature_img").value = "";
                  setLongDesc("");
                  setIsNew(false);
                  setIsEdited(false);
                  setEditorState(EditorState.createEmpty());
                }}
              >
                Close
              </button>
              <button
                onClick={() => {
                  createBlogHandler();
                  setTimeout(async () => {
                    await allBlogs();
                    // await getCurrentUserBlogs();
                  }, 3000);
                  setBlogExistingContent({
                    id: "",
                    updated_title: "",
                    updated_category: "",
                    updated_description: "",
                    updated_blog_feature_img: "",
                  });
                  setBlogContent({ title: "", category: "" });
                  setBlogFeaturedImg({ blogFeatureImg: "" });
                  document.getElementById("title").value = "";
                  document.getElementById("category").value = "";
                  document.getElementById("blog_feature_img").value = "";
                  setLongDesc("");
                  setIsNew(false);
                  setIsEdited(false);
                  setEditorState(EditorState.createEmpty());
                }}
                data-bs-dismiss="modal"
                disabled={
                  isEdited === true
                    ? !blogExistingContent.updated_blog_feature_img
                    : !blogContent.title ||
                      !blogContent.category ||
                      !blogFeaturedImg.blogFeatureImg ||
                      !longDesc
                }
                type="button"
                className={"btn btn-" + theme_color}
              >
                <i className="fal fa-spinner-third me-2 loading d-none"></i>
                {isEdited === true ? "Update Blog" : "Create Blog"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
